<template>
  <div id="expertise">
    <article>
      <h1 class="main-title">תחומי עיסוק</h1>
    </article>

    <article>
      <allExpertises id="allExpertises" />
    </article>

    <article>
      <copyRights id="copyRights" />
    </article>
  </div>
</template>

<script>
import allExpertises from "@/components/AllExpertises.vue";
import copyRights from "@/components/CopyRights.vue";

export default {
  name: "expertise",
  components: {
    allExpertises,
    copyRights
  },
  metaInfo() {
    return {
      title: "איילת נוף תחומי עיסוק",
      meta: [
        {
          name: "description",
          content: "המשרד עוסק בתחומים רבים ובעל ניסיון וידע רב"
        }
      ]
    };
  }
};
</script>

<style scoped>
.main-title{
padding-bottom: 5.5vh;
}

#allExpertises {
  width: 72%;
  margin: 0 auto;
}
#copyRights {
  padding-top: 0.72rem;
}
</style>
